import { IonBackButton, IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import MoveStockForm from "../components/MoveStockForm";

const MoveStock: React.FC = () => {
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton />
            <IonMenuButton />
          </IonButtons>
          <IonTitle>Move Stock</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <MoveStockForm />
      </IonContent>
    </IonPage>
  );
};

export default MoveStock;
